<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-bell text-primary"></i> Reminders</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            </div>
        <div class="col-md-3">
          <label class="form-label">Section<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.sectionID">
            <option selected=""></option>
            <option v-for="(item, index) in secList" :key="index" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-3 mt-5">
          <button class="btn btn-sm btn-success me-1" @click="save()">
            <i class="fa fa-search text-white me-1"></i>Go
          </button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
        <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      </div>
      <div class="row" v-if="tableshow">
        <div class="col-md-9 table-responsive mt-2">
         <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
         <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  msg:handleMsg }" />

        </div>
      </div>
       <div v-if="showModal" class="modal-backdrop-div">
      <div class="modal-box modal-box-xl">
          <div class="modal-content ms-4">
            <div class="modal-header mt-3 mb-3">
              <h5 class="modal-title text-primary" id="studentDetailsModalLabel"> Contact Details </h5>
              <button type="button" class="btn-close ms-auto me-5"  aria-label="Close"  @click="closeModal"> </button>
            </div>
            <div class="modal-body">
             <div class="row mt-3">
          <div class="col-md-6">
            <p><strong>Name : </strong><span> {{ Studentdetail.firstName }}</span></p>
          </div>
          <div class="col-md-6">
           <p><strong>Mobile No. : </strong><span> {{ Studentdetail.phone }}</span></p>
          </div>
          <div class="col-md-6">
           <p><strong>Class : </strong><span> {{ clsList.find(c => c._id === Studentdetail.clsID)?.name }}</span></p>
          </div>
          <div class="col-md-6">
           <p><strong>Section : </strong><span> {{ secList.find(s => s._id === Studentdetail.sectionID)?.Name }}</span></p>
          </div>
          <div class="col-md-10">
           <textarea class="form-control form-control-sm" type="text"  v-model="studentMessage"></textarea>
          </div>
          <div class="col-md-10 mb-2">
           <div class=" col-md-12 d-flex mt-2">
              <a :href="`https://api.whatsapp.com/send?phone=91${Studentdetail.phone}&text=${encodeURIComponent(studentMessage)}`" target="_blank" > <button class="btn btn-sm btn-darknavy"><i class="fa fa-save text-white"></i> Save </button></a>
            <button type="button" class="btn btn-sm btn-info ms-md-auto ms-2"  @click="closeModal">Close</button>
            </div>

          </div>
        </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import {  api } from '@/utils/helpers.js';
import { ref} from 'vue'
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList } = schoolStore();
const  Obj = ref( { clsID: "", sectionID: "",  })
const   msgObj= ref({ msg: "", role: "", show: false, })
const   errors= ref({})
const showModal= ref(false)
const Studentdetail = ref(null);
const studentMessage = ref("");
const tableshow = ref(false)
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Roll No', key: 'rollNo' },
  { label: 'Name', key: 'firstName' },
  { label: 'Class', key: 'cls' },
  { label: 'Father Name', key: 'fatherName' }
]);
const handleMsg = (row) =>{
  Studentdetail.value = row;
 showModal.value = true
}
const closeModal = () => {
  showModal.value = false;
   studentMessage.value = "";
}
const rows=ref([])
    const reset= async() => {
      Obj.value = { clsID: "", sectionID: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
      tableshow.value=false;
    }
    const progress = ref(0)
    const save= async()=> {
      let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
       const fields = {
        Class: { value: Obj.value.clsID, validators: [isRequired], },
        Section: { value: Obj.value.sectionID, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        await api .get(`/students/clssection/${Obj.value.clsID}/${Obj.value.sectionID}`) .then((response) => 
        { rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1, 
        fatherName: item.parent?.fatherName || '',
        phone: item.parent?.phone || '',
          cls: `${clsList.value.find(c => c._id === item.clsID)?.name || ''}${clsList.value.find(c => c._id === item.clsID)?.name ? (secList.value.find(s => s._id === item.sectionID)?.Name ? ' (' + secList.value.find(s => s._id === item.sectionID)?.Name + ')' : '') : ''}`,
        })); 
      progress.value = 0
      clearInterval(progressInterval)
      tableshow.value=true;
      });
   }
  }
</script>